import React, { useState } from "react";
import { Container, Modal, Button } from "react-bootstrap"; // Using React-Bootstrap

const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // To control the popup

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch("https://portfolio-backend-1-nmwf.onrender.com/api/contactme/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });

      if (response.ok) {
        setShowModal(true); // Show popup on success
        setName("");
        setEmail("");
        setMessage("");
      } else {
        alert("Failed to send the message. Please try again."); // Fallback error handling
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Container fluid className="contact-section">
          <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="contact">
              <p className="heading">Contact</p>
        <div className="input-wrapper">
              <div className="input-div">
                <input
                  type="text"
                  value={name}
                  className="input"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name"
                  required
                />
              </div>
              </div>
              
            <div className="input-wrapper">

              <div className="input-div">
                <input
                  className="input"
                  value={email}
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email Address"
                  required
                />
              </div>
              </div>

          <div className="input-wrapper">
              <div className="input-div">
                <input
                  className="input"
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Message"
                  required
                />
              </div>
            </div>

              <div className="button-div">
                {!isLoading && (
                  <button type="submit" className="email-submit">
                    Send
                  </button>
                )}
                {isLoading && <div className="loading">Sending...</div>}
              </div>
            </div>
          </div>
        </Container>
      </form>

      {/* Modal for Message Sent */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Message Sent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Thank you for contacting us. We will get back to you shortly!
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContactForm;
